module.exports = __webpack_public_path__ + "static/media/bei2.06f69895.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/bei2.png
// module id = 394
// module chunks = 0